import { render, staticRenderFns } from "./LetterDetails.vue?vue&type=template&id=2163dc47&scoped=true"
import script from "./LetterDetails.vue?vue&type=script&lang=js"
export * from "./LetterDetails.vue?vue&type=script&lang=js"
import style0 from "./LetterDetails.vue?vue&type=style&index=0&id=2163dc47&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2163dc47",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2163dc47')) {
      api.createRecord('2163dc47', component.options)
    } else {
      api.reload('2163dc47', component.options)
    }
    module.hot.accept("./LetterDetails.vue?vue&type=template&id=2163dc47&scoped=true", function () {
      api.rerender('2163dc47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/announcements/AddLetter/components/LetterDetails.vue"
export default component.exports